<template>
  <div class="basic_wrap">
    <bsHeader
      :title="$t('user.rewards')"
      @backurl="$router.back()"
    />
    
    <div class="main_wrap">
      
      <!-- ================= 1. 顶部统计卡片 ================= -->
      <div class="card_box top_stats_card">
        <div class="total_balance_section">
          <div class="label_gray">{{ $t('utils.lunlog43') }}</div>
          <div class="big_money">{{ common.currency_symbol_basic() }}{{ common.precision_basic(user.balance) }}</div>
        </div>
        <div class="split_stats">
          <div class="stat_box">
            <div class="stat_val">{{ common.currency_symbol_basic() }}{{ common.precision_basic(user.today) }}</div>
            <div class="stat_label">{{ $t('rewards.today') }}</div>
          </div>
          <div class="stat_box">
            <div class="stat_val">{{ common.currency_symbol_basic() }}{{ common.precision_basic(user.total) }}</div>
            <div class="stat_label">{{ $t('rewards.total') }}</div>
          </div>
        </div>
      </div>

      <!-- ================= 2. 奖励任务列表 ================= -->
      <div class="card_box task_list_card">
        <!-- 注册奖励 -->
        <div class="task_item" v-show="rewards.register > 0">
          <div class="task_left">
            <div class="icon_round orange_bg">📝</div>
            <span class="task_name">{{ $t('rewards.register') }}</span>
          </div>
          <div class="task_right done_text">{{ $t('tabs.done') }}</div>
        </div>

        <!-- 邀请好友 -->
        <div class="task_item" v-show="rewards.invite > 0" @click="$router.push('team')">
          <div class="task_left">
            <div class="icon_round blue_bg">🎁</div>
            <span class="task_name">{{ $t('rewards.invite') }}</span>
          </div>
          <div class="task_right link_arrow">
            <span class="green_money">{{ common.currency_symbol_basic() }}{{ common.precision_basic(rewards.invite) }}</span>
            <span class="arrow">›</span>
          </div>
        </div>

        <!-- 每日投资 -->
        <div class="task_item" v-show="rewards.invest > 0" @click="user.invest_status == 0 ? $router.push('invest') : null">
          <div class="task_left">
            <div class="icon_round cyan_bg">📈</div>
            <span class="task_name">{{ $t('rewards.invest') }}</span>
          </div>
          <div class="task_right">
            <span v-if="user.invest_status == 0" class="link_arrow">
              <span class="green_money">{{ common.currency_symbol_basic() }}{{ common.precision_basic(rewards.invest) }}</span>
              <span class="arrow">›</span>
            </span>
            <span v-else class="done_text">{{ $t('tabs.done') }}</span>
          </div>
        </div>

        <!-- 每日登录 -->
        <div class="task_item" v-show="rewards.login > 0">
          <div class="task_left">
            <div class="icon_round purple_bg">📅</div>
            <span class="task_name">{{ $t('rewards.login') }}</span>
          </div>
          <div class="task_right done_text">{{ $t('tabs.done') }}</div>
        </div>
      </div>

      <!-- ================= 3. 奖励记录列表 ================= -->
      <div class="record_list_card">
        <van-list
          v-model="loading"
          offset="0"
          :finished="finished"
          :finished-text="$t('utils.noData')"
          @load="onLoad"
        >
          <div class="record_item" v-for="(item, index) in list" :key="index">
            <div class="record_time">{{ item.act_time }}</div>
            <div class="record_content">
              <span class="record_desc">{{ $t('fundType.type'+item.fund_type) }}</span>
              <span class="record_money green">{{ common.currency_symbol_basic() }}{{ common.precision_basic(item.money) }}</span>
            </div>
          </div>
        </van-list>
      </div>
      
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import { Icon, Cell, CellGroup, List } from "vant";

Vue.use(Cell).use(CellGroup).use(Icon).use(List);

export default {
  name: "Rewards",
  components: { bsHeader },
  data() {
    return {
      data: [],
      empty: false,
      loading: false,
      finished: false,
      list: [],
      user: {
        balance: 0,
        today: 0,
        yesterday: 0,
        total: 0,
        auth_status: 0,
        invest_status: 0
      },
      rewards: {
        authentication: 0,
        invest: 0,
        invite: 0,
        authentication_status: true,
        invest_status: true,
        login: 0,
        register: 0
      },
      page: 1,
      listRows: 8,
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
    // 【修正2】页面加载时主动触发第一次数据请求
    this.onLoad();
  },
  methods: {
    start() {
      Fetch('/user/getReward').then(r => {
        this.user = r.data.user;
        this.rewards = r.data.reward;
      })
    },
      onLoad() {
        // 【关键修复】：只要 finished 为 true，就彻底停止。
        // 不要把 loading 作为拦路石，让 van-list 自己通过 loading 变量控制转圈。
        if (this.finished) {
          return;
        }
  
        // 请求数据前，必须手动将 loading 置为 true，否则不会再次触发
        this.loading = true;
  
        Fetch('/user/rewardRecord', {
          page: this.page,
          listRows: this.listRows,
        }).then(r => {
          // 每次请求回来，一定要关掉 loading，否则 van-list 会永远卡在转圈状态
          this.loading = false;
          
          // 如果后端返回空数组，直接结束
          if (r.data.list.length === 0) {
            this.finished = true;
            return;
          }
  
          var list = r.data.list;
          for (var i = 0; i < list.length; i++) {
            this.list.push(list[i]);
          }
          
          // 判断是否全部加载完毕
          if (this.list.length >= r.data.total) {
            this.finished = true;
          } else {
            this.page = this.page + 1;
          }
        }).catch(() => {
          // 如果报错了，也要关掉 loading，防止永远转圈
          this.loading = false;
        });
      }
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  position: relative;
  height: 100%;
  min-height: 100vh;
  overflow-y: auto;        /* 【核心修复】：允许内部内容上下滚动 */
  -webkit-overflow-scrolling: touch; /* 手机端顺畅滚动 */
  padding-bottom: 60px;
  background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
    padding-bottom: 60px;    /* 底部留白，看到按钮 */
}

.main_wrap {
  padding: 20px 16px 0;
}

/* ================= 通用白色卡片 ================= */
.card_box {
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(24, 61, 122, 0.04);
  border: 1px solid rgba(176, 202, 240, 0.3);
}

/* ================= 1. 顶部统计卡片 ================= */
.top_stats_card {
  padding: 20px 16px;
  text-align: center;

  .total_balance_section {
    margin-bottom: 20px;
    .label_gray {
      font-size: 14px;
      color: #64748b;
      margin-bottom: 6px;
    }
    .big_money {
      font-size: 22px;
      font-weight: 800;
      color: #111;
    }
  }

  .split_stats {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .stat_box {
      flex: 1;
      text-align: center;
      padding: 0 8px;
      position: relative;
      
      &:first-child::after {
        content: '';
        position: absolute;
        right: 0;
        top: 10%;
        height: 80%;
        width: 1px;
        background: #e2e8f0;
      }

      .stat_val {
        font-size: 16px;
        font-weight: 700;
        color: #111;
        margin-bottom: 4px;
      }
      .stat_label {
        font-size: 13px;
        color: #64748b;
      }
    }
  }
}

/* ================= 2. 奖励任务列表 ================= */
.task_list_card {
  padding: 8px 0;

  .task_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    border-bottom: 1px solid #f1f5f9;
    cursor: pointer;
    transition: background 0.15s;
    
    &:last-child {
      border-bottom: none;
    }
    &:active {
      background: #fafbfc;
    }

    .task_left {
      display: flex;
      align-items: center;
      gap: 12px;

      .icon_round {
        width: 36px;
        height: 36px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        background: #f1f5f9;
        color: #334155;
        
        &.orange_bg { background: #fff7ed; color: #ea580c; }
        &.blue_bg { background: #eff6ff; color: #2563eb; }
        &.cyan_bg { background: #ecfdf5; color: #0d9488; }
        &.purple_bg { background: #f3e8ff; color: #9333ea; }
      }

      .task_name {
        font-size: 15px;
        font-weight: 600;
        color: #1a2742;
      }
    }

    .task_right {
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 6px;
      
      &.done_text {
        color: #94a3b8;
      }
      &.link_arrow {
        cursor: pointer;
        .green_money {
          color: #16a34a;
          font-weight: 600;
        }
        .arrow {
          color: #94a3b8;
          font-size: 18px;
          font-weight: 300;
        }
      }
    }
  }
}

/* ================= 3. 奖励记录列表 ================= */
.record_list_card {
  padding: 0;

  .record_item {
    background: #ffffff;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 10px;
    box-shadow: 0 2px 8px rgba(24, 61, 122, 0.04);
    border: 1px solid rgba(176, 202, 240, 0.3);

    .record_time {
      font-size: 13px;
      color: #64748b;
      margin-bottom: 12px;
    }

    .record_content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .record_desc {
        font-size: 15px;
        font-weight: 600;
        color: #111;
      }
      .record_money {
        font-size: 15px;
        font-weight: 700;
        &.green { color: #16a34a; }
      }
    }
  }
}
</style>